import { render, staticRenderFns } from "./otp_generator.vue?vue&type=template&id=5a47786e&"
import script from "./otp_generator.vue?vue&type=script&lang=js&"
export * from "./otp_generator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports